import { INTEGRATION_STATUS_COLORS } from '@/types/integrations'

interface IntegrationStatusBadgeProps {
  status?: string | null
  // A soft failure surfaces as a "Warning" pill instead of the raw status, unless the
  // connection has already escalated to a hard "Error" — in which case Error wins.
  isSoftFailure?: boolean
  className?: string
}

/**
 * The status/health pill shown on integration panels. Renders an amber "Warning" badge
 * while a connection is in a soft-failure state, otherwise the status itself coloured by
 * INTEGRATION_STATUS_COLORS (defaulting to "Active"). Shared by the standard integration
 * panel and the bespoke HubSpot summary so both read identically.
 */
export function IntegrationStatusBadge({ status, isSoftFailure, className = '' }: IntegrationStatusBadgeProps) {
  const isWarning = isSoftFailure && status !== 'Error'
  if (isWarning) {
    return (
      <span className={`px-2 py-0.5 rounded-md text-[10px] font-medium bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300 ${className}`}>
        Warning
      </span>
    )
  }
  return (
    <span className={`px-2 py-0.5 rounded-md text-[10px] font-medium ${INTEGRATION_STATUS_COLORS[status || 'Active'] || ''} ${className}`}>
      {status || 'Active'}
    </span>
  )
}
